











import { Vue, Component, Watch } from "vue-property-decorator";
import apexChart from "vue-apexcharts";
import RequestHandler from "@/assets/ts/requestHandler.ts";
const requestHandler = new RequestHandler();

@Component({
  components: {
    apexChart
  }
})
export default class ReportsSmall extends Vue {
  barChartOptions = {
    chart: {
      events: {
        dataPointSelection: (event: any, chartcontext: any, config: any) => {
          this.$emit(
            "click",
            ["Daily", "Weekly", "Monthly"][config.dataPointIndex]
          );
        }
      }
    },
    fill: {
      colors: ["#8EC582"]
    },
    title: {
      text: "Transaction Totals"
    },
    xaxis: {
      categories: ["Daily", "Weekly", "Monthly"]
    }
  };
  barChartSeries = [
    {
      name: "Transactions",
      data: [0, 0, 0]
    }
  ];
  updateInterval = 0;
  transactionCounts: any = {};
  showChart = true;

  @Watch("reportData")
  dataChanged() {
    (this.$refs.apexChart as any).updateSeries([
      {
        name: "Transactions",
        data: this.reportData
      }
    ]);
  }

  get reportData() {
    const dataArr: Array<string> = [];
    if (this.transactionCounts == undefined) return [];
    Object.keys(this.transactionCounts).forEach((countKey: string) => {
      dataArr.push(this.transactionCounts[countKey]);
    });
    return dataArr;
  }

  async updateTransactionSummary() {
    try {
      this.transactionCounts = await requestHandler.call({
        action: "getTransCounts"
      });
    } catch (e) {
      console.error(e);
    }
  }

  beforeUnmount() {
    this.showChart = false;
  }

  destroyed() {
    clearInterval(this.updateInterval);
  }

  async created() {
    await this.updateTransactionSummary();
    this.dataChanged();
    this.updateInterval = setInterval(() => {
      this.updateTransactionSummary();
    }, 15 * 60000); //15min interval
  }
}
